/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ActionManager, ActionManagerFn } from '../../registry/Component.type';
import { baseActionManager, baseActionProps } from '../../registry/Components';
import { defaultValue } from './ActionApproveWorkflow';

const ActionApproveWorkflowManager: ActionManagerFn<'ActionApproveWorkflow'> = (
  platform: Platform,
): ActionManager<'ActionApproveWorkflow'> => {
  return {
    ...baseActionManager(platform, 'ActionApproveWorkflow'),
    isChildAllowed: (page, item, childType) =>
      ['ActionOnResponse'].includes(childType),
    defaultValue,
    props: {
      ...baseActionProps,
    },
    replaceableWith: ['ActionRejectWorkflow'],
    name: 'Approve Workflow',
    icon: { iconName: 'file-check' },
    description: `Use this action to approve a workflow. This action will only work when the page is opened via. the link generated by wf.pageUrlForApproval() call used in the Approval node.

#### On Response

Use \`On Response\` child action to perform further actions after receiving the response from reject workflow call.

\`\`\`javascript
// The JSON Object from the server will be available as $._.response, which contains the following attributes
approvalStatus, // 'Approved',
approver, // Approver's userName,
executionId,
nodeId,
nodeType,
version, // Workflow UID
wfInstUid, // Workflow Instance UID
wfUid, // Workflow UID
// Sample expression using the above values sent by the server
\`\${$._.response.approvalStatus} \${$._.response.approver}!\`
\`\`\`
`,
  };
};

export default ActionApproveWorkflowManager;
